import { apiClient, handleApiRequest } from './client'

export interface SubstitutionsLogEntry {
  lesson_request_id: string
  request_id: string
  date: string | null
  time_slot_name: string | null
  start_time: string | null
  end_time: string | null
  subject_name: string | null
  klass_name: string | null
  requester_name: string | null
  substitute_name: string | null
  lesson_index: number
  lesson_count: number
  hr_status: 'unprocessed' | 'settled' | 'skipped'
  hr_payout: 'paid_out' | 'lesson_account' | null
  hr_cost_bearer: string | null
  hr_amount: number | null
  hr_note: string | null
  hr_decided_at: string | null
  hr_adjusted: boolean
  chat_unread_count: number
}

export interface SubstitutionsLogKpis {
  total: number
  unprocessed: number
  settled: number
  skipped: number
}

export interface SubstitutionsLogResponse {
  items: SubstitutionsLogEntry[]
  total: number
  limit: number | null
  offset: number
  kpis: SubstitutionsLogKpis
  hr_module_enabled?: boolean
}

export interface SubstitutionsLogParams {
  date_from?: string
  date_to?: string
  all?: boolean
  teacher_id?: string
  search?: string
  hr_statuses?: string[]
  hr_payouts?: string[]
  unread_only?: boolean
  sort?: string
  limit?: number
  offset?: number
}

function buildQuery(params: SubstitutionsLogParams): string {
  const q = new URLSearchParams()
  if (params.date_from) q.set('date_from', params.date_from)
  if (params.date_to) q.set('date_to', params.date_to)
  if (params.all) q.set('all', 'true')
  if (params.teacher_id) q.set('teacher_id', params.teacher_id)
  if (params.search) q.set('search', params.search)
  if (params.hr_statuses?.length) q.set('hr_statuses', params.hr_statuses.join(','))
  if (params.hr_payouts?.length) q.set('hr_payouts', params.hr_payouts.join(','))
  if (params.unread_only) q.set('unread_only', 'true')
  if (params.sort) q.set('sort', params.sort)
  if (params.limit != null) q.set('limit', String(params.limit))
  if (params.offset != null) q.set('offset', String(params.offset))
  const s = q.toString()
  return s ? `?${s}` : ''
}

export const substitutionsLogApi = {
  getList: (params: SubstitutionsLogParams) =>
    handleApiRequest<SubstitutionsLogResponse>(
      apiClient.get(`/api/v1/admin/substitutions-log${buildQuery(params)}`)
    ),

  exportCsv: async (params: SubstitutionsLogParams): Promise<void> => {
    const response = await apiClient.get(
      `/api/v1/admin/substitutions-log/export${buildQuery(params)}`,
      { responseType: 'blob' }
    )
    const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8' })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    const now = new Date()
    const localIso = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`
    link.download = `stellvertretungsliste_${localIso}.csv`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  },
}
